import React, { useEffect, useState } from 'react';
import parse from 'html-react-parser';
import Button from '../../Button';
import Spacing from '../../Spacing';

export default function BannerSectionStyle3({
  bgUrl,
  imgUrl,
  title,
  title2,
  subTitle,
  subTitle2,
  btnText,
  btnUrl,
}) {
  const [isAnimated, setIsAnimated] = useState(false);

  useEffect(() => {
    // Trigger animation on mount
    setIsAnimated(true);
  }, []);

  // Same as home Hero: image in back, overlay so it’s visible lightly ($primaryDark / $bodyBg)
  const heroStyleOverlay = 'linear-gradient(135deg, rgba(3, 16, 30, 0.92) 0%, rgba(10, 15, 26, 0.85) 100%)';
  const bgStyle = {
    backgroundImage: `${heroStyleOverlay}, url(${bgUrl})`,
    backgroundSize: 'cover',
    backgroundPosition: 'top center',
    backgroundRepeat: 'no-repeat',
    backgroundAttachment: 'fixed',
  };

  return (
    <section
      className="cs_banner cs_style_3 cs_bg_filed"
      style={bgStyle}
    >
      <style>
        {`
          @keyframes growAndTurn {
            0% {
              transform: scale(0.5) rotate(-10deg);
              opacity: 0;
            }
            50% {
              transform: scale(1.1) rotate(5deg);
            }
            100% {
              transform: scale(1) rotate(0deg);
              opacity: 1;
            }
          }
          .cs_banner_title_animated {
            animation: growAndTurn 1.2s ease-out forwards;
          }
        `}
      </style>
      <div className="cs_banner_img">
        <img src={imgUrl}  className="cs_main_banner_img" />
      </div>
      <div className="container">
        <div className="cs_banner_text">
          <h2 
            className={`cs_banner_title cs_fs_72 ${isAnimated ? 'cs_banner_title_animated' : ''}`}
            style={{
              transformOrigin: 'center center',
            }}
          >
            {parse(title)}
          </h2>
          <p className="cs_banner_subtitle cs_fs_20 mb-0 cs_heading_color">
            {parse(subTitle)}
          </p>
          {btnText && (
            <>
              <Spacing md="25" lg="25" xl="25" />
              <Button btnUrl={btnUrl} btnText={btnText} />
            </>
          )}
        </div>
      </div>
    </section>
  );
}
